export default __webpack_public_path__ + "static/media/exclamation.79c7750b.svg";